<template>
  <div class="step-outer-box">
    <ChapterFilter v-if="chapterDetail" :theme="chapterDetail.theme"></ChapterFilter>
    <div class="step-content-box">
      <div class="step-profile">
        <div class="profile-item" v-if="chapterDetail&&chapterDetail.task_description">
          <div class="profile-label">线下基地实践</div>
          <div class="profile-content">
            {{ chapterDetail.task_description }}
          </div>
        </div>

        <div class="profile-item">
          <div class="profile-label">数字实践地图</div>
          <div v-if="courseStudys && courseStudys[routeIndex]" class="profile-map">
            <!-- <EchartsMap ref="mapRef" :mapDate="mapDate" @submitPoint="listenSubmit"></EchartsMap> -->
            <TianMap ref="mapRef" :mapDate="mapDate" @submitPoint="listenSubmit"></TianMap>
          </div>
        </div>
      </div>
      <div class="step-route">
        <div class="step-header">梯级研学路线</div>
        <div class="step-content" v-if="courseStudys&&courseStudys.length>0">
          <div class="route-header">
            <div class="route-header-inner">
              <div :class="['header-item',routeIndex == index?'active':'']" v-for="item,index in courseStudys" :key="index" @click="currentRoute(index)">
                <a-popover v-if="(`线路${utils.changeNumToHan(index+1)}：${item.name}`).length > 30" placement="bottom">
                  <template slot="content">
                    <div>线路{{ utils.changeNumToHan(index+1) }}：{{ item.name }}</div>
                  </template>
                  线路{{ utils.changeNumToHan(index+1) }}：{{ item.name }}
                </a-popover>
                <template v-else>线路{{ utils.changeNumToHan(index+1) }}：{{ item.name }}</template>
              </div>
            </div>

          </div>
          <div class="route-content">
            <div class="route-con-item">
              <div class="route-con-label">研学安排：</div>
              <div class="route-con-text" v-html="courseStudys[routeIndex].schedule"></div>
            </div>
            <div class="route-con-item">
              <div class="route-con-label">研学目的：</div>
              <div class="route-con-text" v-html="courseStudys[routeIndex].purpose"></div>
            </div>
            <div class="route-con-item">
              <div class="route-con-label">线路点位：</div>
              <template>
                <div class="route-con-list" v-if="courseStudys && courseStudys[routeIndex] && courseStudys[routeIndex].course_study_hubs.length>0">
                  <div class="route-item" :class="{last:rIndex+1==courseStudys[routeIndex].course_study_hubs.length}" v-for="routeItem,rIndex in courseStudys[routeIndex].course_study_hubs" :key="rIndex" @click="jumpHubs(routeItem)">
                    <div class="route-index">
                      <!-- eslint-disable-next-line vue/no-parsing-error -->
                      {{ rIndex < 10 ? `0${rIndex+1}` : rIndex+1 }}
                    </div>
                    <div class="route-card">
                      <div class="card-normal">
                        <div class="route-cover">
                          <div class="route-img" :style="`background:url(${routeItem.cover})no-repeat center/cover`"></div>
                          <div v-if="routeItem.is_finish == 2" class="finish-icon"></div>
                        </div>

                      </div>
                      <div class="card-hover">
                        <div class="hover-scroll">
                          <div class="route-location">地址：{{ routeItem.address }}</div>
                          <div class="route-intro">
                            <p v-html="routeItem.intro"></p>
                          </div>
                        </div>
                      </div>

                      <div class="route-name">
                        <p>{{ routeItem.name }}</p>
                      </div>

                      <div class="route-button" v-if="routeItem.url">在线查看 ></div>
                    </div>
                  </div>
                  <div class="flex-visible"></div>
                  <div class="flex-visible"></div>
                </div>
                <template v-else>
                  <a-empty />
                </template>
              </template>
            </div>
          </div>
        </div>
        <template v-else>
          <a-empty />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import services from '../../../assets/js/services'
import ChapterFilter from '../../../components/student/ChapterFilter'
// import EchartsMap from '../../../components/student/EchartsMap.vue'
import TianMap from '../../../components/student/TianMap.vue'
import { mapState, mapActions } from 'vuex';
import utils from '../../../assets/js/utils';

export default {
  name: 'stepThree',
  data () {
    return {
      utils,
      routeIndex: 0,
      chapterDetail: null,
      courseStudys: null,
      mapDate: null,
      isOverflowing: false, // 是否溢出
    }
  },
  components: {
    ChapterFilter,
    // EchartsMap,
    TianMap
  },
  computed: {
    ...mapState({
      appsUserInfo: state => state.appsLogin.appsUserInfo,
    }),
  },


  async mounted () {
    await this.$watch('$route', this.getTaskData, { immediate: true });
  },
  methods: {
    ...mapActions(['methodActivityDetail']),
    // 判断内容是否溢出

    currentRoute (index) {
      this.routeIndex = index
      this.mapDate = this.courseStudys && this.courseStudys[this.routeIndex] && this.courseStudys[this.routeIndex].course_study_hubs
      this.$nextTick(() => {
        this.$refs.mapRef.resetMap()
      })
    },
    async getTaskData (isCurrentRoute = false) {
      let query = this.$route.query
      let params = {
        code: "t003",
        activity_id: query.activity_id,
        course_id: query.course_id,
        chapter_id: query.chapter_id
      }
      let result = await services.getCenterTaskData(params)
      if (result.code == "0000") {
        for (let i = 0; i < result.data.course_studys.length; i++) {
          result.data.course_studys[i].course_study_hubs.map(item => {
            item.lng_lat_arr = item.lng_lat.split(",")
            return item
          })
        }
        this.chapterDetail = result.data.chapter
        this.courseStudys = result.data.course_studys
        if (isCurrentRoute && result.data.course_studys && result.data.course_studys[this.routeIndex]) {
          this.mapDate = this.courseStudys[this.routeIndex] ? this.courseStudys[this.routeIndex].course_study_hubs : null
          this.currentRoute(this.routeIndex)
        } else {
          this.mapDate = this.courseStudys[0] ? this.courseStudys[0].course_study_hubs : null
          this.currentRoute(0)
        }
      }
    },
    async jumpHubs (item) {
      if (item.url) {
        let query = this.$route.query
        let params = {
          activity_id: query.activity_id,
          course_id: query.course_id,
          chapter_id: query.chapter_id,
          school_id: this.appsUserInfo.school_id,
          course_study_hub_id: item.id,
          user_id: this.appsUserInfo.id,
        }
        // window.open(item.url, "_blank", 'noopener,noreferrer,resizable')
        window.open('javascript:window.name;', '<script>location.replace("' + item.url + '")<\/script>'); // eslint-disable-line

        let result = await services.sutmitT003(params) // 提交学习
        if (result.code == "0000") {
          this.getTaskData(true) // 更新列表完成状态
        }
      }

    },
    listenSubmit (item) {
      this.jumpHubs(JSON.parse(item))
    }
  }
}
</script>

<style lang="less" scoped>
.step-outer-box {
    width: 100%;
    .step-content-box {
        border: 1px solid #e7eaec;
        background: #ffffff;
        padding: 18px 25px;
        min-height: calc(100vh - 165px);
        .step-profile {
            .profile-item {
                display: flex;
                &:not(:last-child) {
                    margin-bottom: 17px;
                }
                .profile-label {
                    width: 112px;
                    height: 28px;
                    background: #bc7a6e;
                    border-radius: 14px 0px 0px 14px;
                    text-align: center;
                    line-height: 28px;
                    font-weight: bold;
                    font-size: 14px;
                    color: #ffffff;
                    padding: 0 14px;
                }
                .profile-content {
                    flex: 1;
                    background: #fcf2f0;
                    border-radius: 4px;
                    font-size: 14px;
                    color: #2f2626;
                    line-height: 18px;
                    height: max-content;
                    padding: 5px 14px;
                    max-height: 120px;
                    overflow-y: auto;
                }
                .profile-map {
                    flex: 1;
                    height: max-content;
                    border: 1px solid #c0a09d;
                }
            }
        }
        .step-route {
            padding-top: 20px;
            .step-header {
                height: 32px;
                background: linear-gradient(90deg, #a82822 0%, #b84b3c 100%);
                line-height: 32px;
                padding: 0 16px;
                font-weight: bold;
                font-size: 14px;
                color: #ffffff;
            }
            .step-content {
                padding-top: 20px;
                .route-header {
                    width: 100%;
                    // overflow-x: auto;
                    // &::-webkit-scrollbar-thumb {
                    //     background: #8b8b8b;
                    //     border-radius: 10px;
                    // }
                    .route-header-inner {
                        // padding-bottom: 5px;
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        // justify-content: center;
                        // white-space: nowrap;
                        .header-item {
                            flex-shrink: 0;
                            width: 48%;
                            height: 32px;
                            background: #fff3f2;
                            border-radius: 16px;
                            border: 1px solid #cc9d9a;
                            text-align: center;
                            line-height: 30px;
                            font-size: 14px;
                            color: #a82822;
                            cursor: pointer;
                            margin-bottom: 8px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            padding: 0 10px;
                            /deep/ span {
                                font-weight: bold;
                            }
                            &.active {
                                background: #a82822;
                                border-color: transparent;
                                color: #ffffff;
                            }
                        }
                    }
                }
                .route-content {
                    padding-top: 12px;
                    .route-con-item {
                        &:not(:last-child) {
                            margin-bottom: 22px;
                        }
                        .route-con-label {
                            font-weight: bold;
                            font-size: 14px;
                            color: #3c3c3e;
                            line-height: 1;
                            padding-bottom: 14px;
                        }
                        .route-con-text {
                            width: 100%;
                            background: #f8f8f8;
                            font-size: 14px;
                            color: #7e8287;
                            line-height: 17px;
                            padding: 7px 16px;
                            max-height: 120px;
                            overflow-y: auto;
                        }
                        .route-con-list {
                            display: flex;
                            justify-content: space-between;
                            flex-wrap: wrap;
                            .flex-visible {
                                flex: 0 0 288px;
                                visibility: hidden;
                                display: inline-block;
                            }
                            .route-item {
                                width: 288px;
                                margin-bottom: 36px;
                                position: relative;
                                cursor: pointer;
                                &:nth-child(4n)::after,
                                &.last::after {
                                    opacity: 0;
                                }

                                &::after {
                                    content: '';
                                    display: inline-block;
                                    width: 42px;
                                    height: 50px;
                                    background: url('../../../assets/image/student/stepThree/arrow.png')
                                        no-repeat center/cover;
                                    vertical-align: middle;
                                    position: absolute;
                                    top: 50%;
                                    left: calc(100% + 2px);
                                    transform: translateY(-50%);
                                    pointer-events: none;
                                }
                                &:hover {
                                    .route-button {
                                        display: block;
                                    }
                                    .route-card {
                                        .route-name {
                                            background: #fff3f2;
                                            color: #a82822;
                                        }
                                    }
                                }
                                .route-card {
                                    position: relative;
                                    width: 100%;
                                    height: 100%;
                                    .route-name {
                                        width: 100%;
                                        height: 62px;
                                        background: #ffffff;
                                        border-radius: 0px 0px 4px 4px;
                                        border: 1px solid #e7eaec;
                                        font-size: 14px;
                                        color: #3c3c3e;
                                        padding: 9px 14px;
                                        p {
                                            overflow: hidden;
                                            text-overflow: ellipsis;
                                            display: -webkit-box;
                                            -webkit-box-orient: vertical;
                                            -webkit-line-clamp: 2;
                                        }
                                    }
                                    .card-normal {
                                        border-radius: 4px 4px 0px 0px;
                                        overflow: hidden;
                                        .route-cover {
                                            height: 162px;
                                            position: relative;
                                            .route-img {
                                                width: 100%;
                                                height: 100%;
                                            }
                                            .finish-icon {
                                                width: 24px;
                                                height: 24px;
                                                background: url('../../../assets/image/student/stepOne/wancheng.png')
                                                    no-repeat center/cover;
                                                position: absolute;
                                                right: 3px;
                                                top: 3px;
                                                z-index: 10;
                                            }
                                        }
                                    }
                                }
                                .route-index {
                                    width: 30px;
                                    height: 30px;
                                    background: linear-gradient(
                                        90deg,
                                        #d5893f 0%,
                                        #d7b384 100%
                                    );
                                    border-radius: 15px 15px 0px 0px;
                                    text-align: center;
                                    line-height: 28px;
                                    font-weight: bold;
                                    font-size: 14px;
                                    color: #ffffff;
                                    transform: translateY(2px);
                                }
                                .route-button {
                                    font-size: 14px;
                                    color: #892018;
                                    position: absolute;
                                    left: 50%;
                                    transform: translateX(-50%);
                                    bottom: 6px;
                                    display: none;
                                }
                                .card-normal,
                                .card-hover {
                                    transition: opacity 0.3s ease,
                                        visibility 0.3s ease;
                                }

                                .card-normal {
                                    opacity: 1;
                                    visibility: visible;
                                }

                                .card-hover {
                                    opacity: 0;
                                    visibility: hidden;
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 100%;
                                    height: calc(100% - 92px);
                                    background: rgba(20, 2, 0, 0.76);
                                    border-radius: 4px 4px 0px 0px;
                                    padding: 14px 4px 5px 13px;
                                    .hover-scroll {
                                        width: 100%;
                                        height: 100%;
                                        overflow-y: auto;
                                        padding: 0 13px 5px 0;
                                        &::-webkit-scrollbar-track-piece {
                                            background: transparent;
                                        }
                                    }
                                    .route-location {
                                        font-weight: bold;
                                        font-size: 14px;
                                        color: #ffeab3;
                                        line-height: 20px;
                                    }
                                    .route-intro {
                                        padding-top: 9px;
                                        font-size: 14px;
                                        color: #ffffff;
                                        line-height: 20px;
                                    }
                                }

                                .route-card:hover {
                                    .card-normal {
                                        opacity: 0;
                                        visibility: hidden;
                                    }
                                    .card-hover {
                                        opacity: 1;
                                        visibility: visible;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
@media screen and(max-width:1800px) {
    .step-outer-box {
        .step-content-box {
            .step-route {
                .step-content {
                    .route-content {
                        .route-con-item {
                            .route-con-list {
                                .route-item {
                                    width: 47%;
                                    .route-card {
                                        .card-normal {
                                            .route-cover {
                                                aspect-ratio: 288/162;
                                                height: auto;
                                            }
                                        }
                                    }
                                    &::after {
                                        left: calc(100% + 5px);
                                    }
                                    &:nth-child(2n)::after {
                                        opacity: 0;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>